import { isCapabilityEnabled } from 'owa-capabilities';
import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Remove reference to getHostValue
 *	> While generally we don't want to use getHostValue in code - it is acceptable to use in a capability as it clearly ties back to the feature needing it. */
import { NATIVE, getHostValue } from 'owa-config';
import getIsCurrentThemeModernColor from 'owa-theme/lib/selectors/getIsCurrentThemeModernColor';
import { bleedThroughCapability } from './bleedThroughCapability';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to check in which cases the header full bleed is enabled
 * The header full bleed is enabled when any of the following conditions are met:
 * 1. The bleedThroughCapability is enabled, which means a bleed through theme is set.
 * 2. The mica effect is enabled for the header, which is determined by the
 *    getIsHeaderMicaEffectEnabled function.
 *    The mica effect is enabled for modern color themes in Monarch.
 */
export const headerFullBleedCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return isCapabilityEnabled(bleedThroughCapability) || getIsHeaderMicaEffectEnabled();
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return true; // This capability is supported by default
    },
};

function getIsHeaderMicaEffectEnabled(): boolean {
    // The Mica Effect is enabled for modern color themes in Monarch
    return getIsCurrentThemeModernColor() && getHostValue() === NATIVE;
}
